import { uuidv4 } from '../utils/uuid.js';

var ServiceIdentity;
(function (ServiceIdentity) {
    // core service
    ServiceIdentity["CoreInstance"] = "coreInstance";
    ServiceIdentity["NetworkManager"] = "netManager";
    ServiceIdentity["ConversationManager"] = "conversationManger";
    ServiceIdentity["MessageManager"] = "messageManager";
    ServiceIdentity["ParticipantManager"] = "participantManager";
    ServiceIdentity["EventBus"] = "eventBus";
    ServiceIdentity["Monitor"] = "montior";
    ServiceIdentity["DbProxy"] = "dbProxy";
    ServiceIdentity["CoreApi"] = "coreApi";
    ServiceIdentity["InboxType"] = "inboxType";
    // extension plugin
    ServiceIdentity["ExtensionPlugin"] = "extensionPlugin";
    ServiceIdentity["ExtensionApi"] = "extensionApi";
    ServiceIdentity["BroadcastManager"] = "broadcastManager";
    // emoji
    ServiceIdentity["EmojiPlugin"] = "emojiPlugin";
    // metrics
    ServiceIdentity["MetricsPlugin"] = "metricsPlugin";
    ServiceIdentity["MetricsApi"] = "metricsApi";
    // multimedia
    ServiceIdentity["MultimediaPlugin"] = "multimediaPlugin";
    ServiceIdentity["MultimediaApi"] = "multimediaApi";
    // rtc
    ServiceIdentity["RtcPlugin"] = "rtcPlugin";
    ServiceIdentity["RtcManager"] = "rtcManager";
    ServiceIdentity["RtcApi"] = "rtcApi";
    ServiceIdentity["RtcController"] = "rtcController";
    // shark
    ServiceIdentity["SharkPlugin"] = "sharkPlugin";
    // storage
    ServiceIdentity["StoragePlugin"] = "storagePlugin";
    ServiceIdentity["StorageApi"] = "storageApi";
    // stranger
    ServiceIdentity["StrangerPlugin"] = "strangerPlugin";
    ServiceIdentity["StrangerApi"] = "strangerApi";
    // security
    ServiceIdentity["SecurityPlugin"] = "securityPlugin";
    ServiceIdentity["AuthManager"] = "AuthManager";
})(ServiceIdentity || (ServiceIdentity = {}));
class ServiceContainer {
    constructor() {
        this.services = new Map();
        this.plugins = new Map();
    }
    register(ctxId, identity, value) {
        if (!this.services.has(ctxId)) {
            this.services.set(ctxId, new Map());
        }
        this.services.get(ctxId).set(identity, value);
    }
    resolve(ctxId, identity) {
        var _a;
        return (_a = this.services.get(ctxId)) === null || _a === void 0 ? void 0 : _a.get(identity);
    }
    get instanceCount() {
        return this.services.size;
    }
}
ServiceContainer.Instance = new ServiceContainer();
class RuntimeContext {
    constructor() {
        this.initResult = 0;
        this.cachedToken = '';
        this.id = '';
        this.id = uuidv4();
    }
    get plugin() {
        var _a;
        return (_a = ServiceContainer.Instance.plugins.get(this.id)) !== null && _a !== void 0 ? _a : [];
    }
    set plugin(value) {
        ServiceContainer.Instance.plugins.set(this.id, value);
    }
    register(identity, value) {
        // @ts-ignore
        let realValue = value;
        if (typeof value === 'function') {
            realValue = new value(this);
        }
        ServiceContainer.Instance.register(this.id, identity, realValue);
        return realValue;
    }
    resolve(identity) {
        // @ts-ignore
        return ServiceContainer.Instance.resolve(this.id, identity);
    }
}
class ContextClassBase {
    constructor(ctx) {
        this.__internal_ctx = ctx;
    }
    get ctx() {
        return this.getContext();
    }
    bindContext(ctx) {
        this.__internal_ctx = ctx;
    }
    getContext() {
        return this.__internal_ctx;
    }
    resolve(identity) {
        return this.getContext().resolve(identity);
    }
    register(identity, value) {
        return this.getContext().register(identity, value);
    }
}

export { ContextClassBase, RuntimeContext, ServiceContainer, ServiceIdentity };
//# sourceMappingURL=RuntimeContext.js.map
